import {SetEmailComponent} from './SetEmailComponent';
import {EmailContainerComponent} from './EmailContainerComponent';
import {EmailDialogComponent} from './EmailDialogComponent';
import {EmailDomainDialogComponent} from './EmailDomainDialogComponent';
import {InputEmailComponent} from './InputEmailComponent';

export let loginEmailModule = angular.module('authentication.login.email', []);

loginEmailModule.component('setEmailComponent', SetEmailComponent);
loginEmailModule.component('emailContainerComponent', EmailContainerComponent);
loginEmailModule.component('emailDialogComponent', EmailDialogComponent);
loginEmailModule.component('emailDomainDialogComponent', EmailDomainDialogComponent);
loginEmailModule.component('inputEmail', InputEmailComponent);